import { render, staticRenderFns } from "./blue_glue.vue?vue&type=template&id=35042600&scoped=true"
import script from "./blue_glue.vue?vue&type=script&lang=js"
export * from "./blue_glue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35042600",
  null
  
)

export default component.exports